import React from 'react';

interface MetricTogglePanelProps {
  visibleMetrics: string[];
  onToggleMetric: (metric: string) => void;
}

const MetricTogglePanel: React.FC<MetricTogglePanelProps> = ({
  visibleMetrics,
  onToggleMetric
}) => {
  const metrics = [
    { key: 'production', label: 'Production', color: 'bg-blue-300' },
    { key: 'yield', label: 'Specific Yield', color: 'bg-purple-500' },
    { key: 'pr', label: 'Daily PR', color: 'bg-blue-800' },
    { key: 'efficiency', label: 'Efficiency', color: 'bg-green-500' },
    { key: 'cuf_dc', label: 'CUF DC', color: 'bg-yellow-500' },
    { key: 'cuf_ac', label: 'CUF AC', color: 'bg-orange-500' },
    { key: 'trinomic_loss', label: 'Trinomic Loss', color: 'bg-red-500' }
  ];

  return (
    <div className="bg-white p-4 rounded-lg border">
      <h4 className="text-md font-medium mb-3">Visible Metrics</h4>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {metrics.map(metric => (
          <label key={metric.key} className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={visibleMetrics.includes(metric.key)}
              onChange={() => onToggleMetric(metric.key)}
              className="rounded"
            />
            <div className={`w-3 h-3 rounded ${metric.color}`}></div>
            <span className="text-sm">{metric.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default MetricTogglePanel;